import { AppState } from "state/AppState";
import { Light } from "style/theme/Light";

export const InitialState: AppState = {
    layout: {
        theme: Light
    }
};
